import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './guidelines.component.html',
	styleUrls: ['./guidelines.component.css']
})

export class GuidelinesComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
		console.log("guidelines working");
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/guidelines.component.ts